export const esAccount = {
  'account.admin': 'Administración',
  'account.banks': 'Bancos conectados',
  'account.description':
    'Comparte tus finanzas con personas de confianza o invita a otras personas a descubrir FinanceGo.',
  'account.eyebrow': 'Tu cuenta',
  'account.language': 'Idioma',
  'account.languageDescription':
    'FinanceGo guardará este idioma en tu cuenta y lo usará en tus dispositivos.',
  'account.languageEnglish': 'English',
  'account.languageSpanish': 'Español',
  'account.managePlan': 'Gestionar plan',
  'account.preferences': 'Preferencias',
  'account.preferencesError': 'No se pudo guardar el cambio. Inténtalo de nuevo.',
  'account.preferencesSaved': 'Preferencia guardada.',
  'account.referrals': 'Referidos',
  'account.shared': 'Cuenta compartida',
  'account.support': 'Centro de soporte',
  'account.theme': 'Apariencia',
  'account.themeDark': 'Oscuro',
  'account.themeDescription': 'El tema también actualiza el color de la app instalada.',
  'account.themeLight': 'Claro',
  'account.title': 'Crece acompañado, sin perder el control.',
} as const;

export const enAccount: Record<keyof typeof esAccount, string> = {
  'account.admin': 'Administration',
  'account.banks': 'Connected banks',
  'account.description':
    'Share your finances with people you trust or invite others to discover FinanceGo.',
  'account.eyebrow': 'Your account',
  'account.language': 'Language',
  'account.languageDescription':
    'FinanceGo will save this language to your account and use it across your devices.',
  'account.languageEnglish': 'English',
  'account.languageSpanish': 'Español',
  'account.managePlan': 'Manage plan',
  'account.preferences': 'Preferences',
  'account.preferencesError': 'The change could not be saved. Try again.',
  'account.preferencesSaved': 'Preference saved.',
  'account.referrals': 'Referrals',
  'account.shared': 'Shared account',
  'account.support': 'Support center',
  'account.theme': 'Appearance',
  'account.themeDark': 'Dark',
  'account.themeDescription': 'The theme also updates the installed app color.',
  'account.themeLight': 'Light',
  'account.title': 'Grow together without losing control.',
};
